import { createChildActions } from 'helpers/actions'
import entityNames from 'options/entityNames'

export default createChildActions(entityNames.customers, 'approvalTree')
